import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';

import DetailPage from './DetailPage';

const OrganizationPage = () => {
  const field_icon = {
    type: <BusinessOutlinedIcon className="detail-icon-" />,
    location: <LocationOnOutlinedIcon className="detail-icon-" style={{ color: '#FF6666' }} />,
  };

  const field_heading = {
    contact_information: 'Contact Information',
    mission_statement: 'Mission Statement/Focus Area',
    activities: 'Key Activities or Projects',
    leadership: 'Leadership',
    notes: 'Additional Notes',
  };

  return (
    <DetailPage
      category={'organization'}
      heading={'name'}
      field_icon={field_icon}
      externalLink={{ field: 'website', text: 'Visit Website' }}
      field_heading={field_heading}
    />
  );
};

export default OrganizationPage;
